export const InboardTableDetails = [
  { head: "Warehouse Count", value: 80 },
  { head: "Scheduled Appointment", value: 690 },
  { head: "# Po Count", value: 1790 },
  { head: "Expired pes", value: 96 },
  { head: "Problematic site", value: 8 },
];
